import React from "react";
import type { ComponentType } from "react";
import SubscriptionPackagesBase from "./SubscriptionPackages";
import UnsubscribedLocationsBase from "./UnsubscribedLocations";
import ParticipantPageLayout from "@/components/layouts/page/ParticipantPageLayout";

const SubscriptionPackages = SubscriptionPackagesBase as ComponentType<any>;
const UnsubscribedLocations = UnsubscribedLocationsBase as ComponentType<any>;

export default function PackageSelection({
  selectedBrand,
  pageInfo,
  packages,
  locations,
  selections,
  onContinue,
  loadMoreLocations,
  renderLocationFilters,
  totalLocationCount,
}: any) {
  return (
    <ParticipantPageLayout className="subscription-package-selection mx-lg-5 mx-3">
      <SubscriptionPackages
        packages={packages}
        pageInfo={pageInfo}
        selectedBrand={selectedBrand}
      />
      <UnsubscribedLocations
        packages={packages}
        locations={locations}
        onContinue={onContinue}
        selections={selections}
        loadMoreLocations={loadMoreLocations}
        pageInfo={pageInfo}
        renderLocationFilters={renderLocationFilters}
        totalLocationCount={totalLocationCount}
      />
    </ParticipantPageLayout>
  );
}
